const initialFrontEndUserState = {
  data : [],
  columns: false,
  hasBeenEdited: false
}

export const FrontEndUserReducer = (state = initialFrontEndUserState, action = {}) => {
  
    switch (action.type) {          
        
        case 'FRONTENDUSERDATA':
            return {
              ...state,
              data: action.fetchedFrontEndUserData.data.data,
              columns: action.fetchedFrontEndUserData.data.columns                  
            }   
        case 'USER_HAS_BEEN_EDITED':
            return {
              ...state,
              hasBeenEdited: action.status         
            }    
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FrontEndUserReducer.js